import axios from "axios";
import { features, getConfig } from "../config";
const FALLBACK_TIMEOUT = 2e3;
const PHONE_BASE_URL = "https://services.postcodeanywhere.co.uk/PhoneNumberValidation/Interactive/Validate/v2.10/json3.ws?Key=";
const validatePhoneNumber = async (number) => {
  const { PCA_API_KEY: API_KEY } = getConfig();
  const endpoint = `${PHONE_BASE_URL}${API_KEY}&Phone=${encodeURIComponent(
    `${number}`
  )}`;
  const mockedValidResponse = { IsValid: "Yes", NumberType: "Mobile" };
  try {
    if (!features.pcaPhoneValidation) {
      return mockedValidResponse;
    }
    const response = await axios.get(endpoint, {
      timeout: FALLBACK_TIMEOUT
    }).then((response2) => response2.data.Items[0]);
    if (response?.Error === "8" && response?.Description === "Key daily limit exceeded") {
      return mockedValidResponse;
    }
    return response;
  } catch (e) {
    return mockedValidResponse;
  }
};
const EMAIL_BASE_URL = "https://services.postcodeanywhere.co.uk/EmailValidation/Interactive/Validate/v2.00/json3.ws?Timeout=3000&Key=";
const validateEmail = async (email) => {
  const { PCA_API_KEY: API_KEY } = getConfig();
  const endpoint = `${EMAIL_BASE_URL}${API_KEY}&Email=${encodeURIComponent(
    email
  )}`;
  const mockedValidResponse = { ResponseCode: "Valid" };
  try {
    if (!features.pcaEmailValidation) {
      return mockedValidResponse;
    }
    const response = await axios.get(endpoint, {
      timeout: FALLBACK_TIMEOUT
    }).then((response2) => response2.data.Items[0]);
    if (response?.Error === "8" && response?.Description === "Key daily limit exceeded") {
      return mockedValidResponse;
    }
    return response;
  } catch (e) {
    return mockedValidResponse;
  }
};
const BANK_BASE_URL = `${"https://services.postcodeanywhere.co.uk/BankAccountValidation/Interactive/Validate/v2.00/json3.ws?Key="}`;
const validateBank = async (sortCode, accountNumber) => {
  const { PCA_API_KEY: API_KEY } = getConfig();
  const endpoint = `${BANK_BASE_URL}${API_KEY}&AccountNumber=${encodeURIComponent(
    accountNumber
  )}&SortCode=${encodeURIComponent(sortCode)}`;
  const mockedValidResponse = {
    IsCorrect: true,
    IsDirectDebitCapable: true,
    StatusInformation: "OK",
    CorrectedSortCode: sortCode,
    CorrectedAccountNumber: accountNumber,
    IBAN: "",
    Bank: "Bank account",
    BankBIC: "",
    Branch: "",
    BranchBIC: "",
    ContactAddressLine1: "",
    ContactAddressLine2: "",
    ContactPostTown: "",
    ContactPostcode: "",
    ContactPhone: "",
    ContactFax: "",
    FasterPaymentsSupported: true,
    CHAPSSupported: true
  };
  try {
    if (!features.pcaBankValidation) {
      return mockedValidResponse;
    }
    const response = await axios.get(endpoint, {
      timeout: FALLBACK_TIMEOUT
    }).then((response2) => response2.data.Items[0]);
    if (response?.Error === "8" && response?.Description === "Key daily limit exceeded") {
      return mockedValidResponse;
    }
    return response;
  } catch (e) {
    return mockedValidResponse;
  }
};
const IBAN_BASE_URL = `${"https://services.postcodeanywhere.co.uk/InternationalBankValidation/Interactive/Validate/v1/json3.ws?Key="}`;
const validateIban = async (iban) => {
  const { PCA_API_KEY: API_KEY } = getConfig();
  const endpoint = `${IBAN_BASE_URL}${API_KEY}&IBAN=${encodeURIComponent(iban)}`;
  const mockedValidResponse = {
    IsCorrect: true
  };
  try {
    if (!features.pcaIbanValidation) {
      return mockedValidResponse;
    }
    const response = await axios.get(endpoint, {
      timeout: FALLBACK_TIMEOUT
    }).then((response2) => response2.data.Items[0]);
    if (response?.Error === "8" && response?.Description === "Key daily limit exceeded") {
      return mockedValidResponse;
    }
    return response;
  } catch (e) {
    return mockedValidResponse;
  }
};
export {
  BANK_BASE_URL,
  EMAIL_BASE_URL,
  IBAN_BASE_URL,
  PHONE_BASE_URL,
  validateBank,
  validateEmail,
  validateIban,
  validatePhoneNumber
};
